import { cloneDeep } from 'lodash';

import { GameType } from '../../models/GameStore';
import { ScopeType, getScope } from '../../utils/url';

export const isSpeaking = () => false;
// [GameType.Conversation, GameType.ManuallyEvaluatedConversation].includes(
//   type,
// );

export const isManuallyEvaluated = () => false;
//[GameType.ManuallyEvaluatedConversation].includes(type);

export const isGameType = (
  type: GameType,
  options?: {
    pairing?: boolean | undefined;
    speaking?: boolean | undefined;
    manuallyEvaluated?: boolean | undefined;
  },
) => {
  if (
    // short circuit if checking specifiy type
    !(
      options?.pairing ||
      options?.speaking ||
      options?.manuallyEvaluated ||
      Object.values(GameType).includes(type)
    )
  ) {
    return false;
  }

  return false;
  // return (
  //   (options?.pairing === undefined ||
  //     (type === GameType.Pairing) === options.pairing) &&
  //   (options?.speaking === undefined ||
  //     isSpeaking(type) === options.speaking) &&
  //   (options?.manuallyEvaluated === undefined ||
  //     isManuallyEvaluated(type) === options.manuallyEvaluated)
  // );
};

/*eslint @typescript-eslint/no-unused-vars: ["error", { "ignoreRestSiblings": true }]*/
export const getGameScope: typeof getScope = ({
  classroom,
  gameSet,
  post,
  reportCase,
  gameCollection,
  ...params
} = {}) => {
  const scope: ScopeType = { ...params };
  // TODO: only reportCase scope work in server now
  if (reportCase) {
    scope.reportCase = reportCase;
  }
  // } else if (post) {
  //   scope.post = post;
  //   scope.gameCollection = gameCollection;
  // } else {
  //   scope.classroom = classroom;
  //   scope.gameSet = gameSet;
  //   scope.gameCollection = gameCollection;
  // }

  return getScope(scope);
};

export const mergeSound = <T extends object>(obj: T, src: T): void => {
  if ('sound' in obj && 'sound' in src) {
    obj.sound = cloneDeep(src.sound);
  }
  if ('ttsAudio' in obj && 'ttsAudio' in src) {
    obj.ttsAudio = cloneDeep(src.ttsAudio);
  }
  if ('soundMode' in obj && 'soundMode' in src) {
    obj.soundMode = src.soundMode;
  }
  if ('locale' in obj && 'locale' in src) {
    obj.locale = src.locale;
  }
  if (
    'hint' in obj &&
    'hint' in src &&
    typeof obj.hint === 'object' &&
    obj.hint &&
    typeof src.hint === 'object' &&
    src.hint
  ) {
    mergeSound(obj.hint, src.hint);
  }
  if (
    'first' in obj &&
    'first' in src &&
    typeof obj.first === 'object' &&
    obj.first &&
    typeof src.first === 'object' &&
    src.first
  ) {
    mergeSound(obj.first, src.first);
  }
  if (
    'second' in obj &&
    'second' in src &&
    typeof obj.second === 'object' &&
    obj.second &&
    typeof src.second === 'object' &&
    src.second
  ) {
    mergeSound(obj.second, src.second);
  }
  if (
    'instruction' in obj &&
    'instruction' in src &&
    typeof obj.instruction === 'object' &&
    obj.instruction &&
    typeof src.instruction === 'object' &&
    src.instruction
  ) {
    mergeSound(obj.instruction, src.instruction);
  }
  if (
    'answer' in obj &&
    'answer' in src &&
    typeof obj.answer === 'object' &&
    obj.answer &&
    typeof src.answer === 'object' &&
    src.answer
  ) {
    mergeSound(obj.answer, src.answer);
  }
  if (
    'context' in obj &&
    'context' in src &&
    typeof obj.context === 'object' &&
    obj.context &&
    typeof src.context === 'object' &&
    src.context
  ) {
    mergeSound(obj.context, src.context);
  }
  if (
    'units' in obj &&
    'units' in src &&
    Array.isArray(obj.units) &&
    Array.isArray(src.units)
  ) {
    const units = src.units;
    obj.units.forEach((unit, i) => {
      if (
        unit &&
        units[i] &&
        typeof unit === 'object' &&
        typeof units[i] === 'object'
      ) {
        mergeSound(unit, units[i]);
      }
    });
  }
  if (
    'characters' in obj &&
    'characters' in src &&
    Array.isArray(obj.characters) &&
    Array.isArray(src.characters)
  ) {
    const characters = src.characters;
    obj.characters.forEach((character, i) => {
      if (
        character &&
        characters[i] &&
        typeof character === 'object' &&
        typeof characters[i] === 'object'
      ) {
        mergeSound(character, characters[i]);
      }
    });
  }
  if (
    'words' in obj &&
    'words' in src &&
    Array.isArray(obj.words) &&
    Array.isArray(src.words)
  ) {
    const words = src.words;
    obj.words.forEach((word, i) => {
      if (
        word &&
        words[i] &&
        typeof word === 'object' &&
        typeof words[i] === 'object'
      ) {
        mergeSound(word, words[i]);
      }
    });
  }
  if (
    'pairs' in obj &&
    'pairs' in src &&
    Array.isArray(obj.pairs) &&
    Array.isArray(src.pairs)
  ) {
    const pairs = src.pairs;
    obj.pairs.forEach((pair, i) => {
      if (
        pair &&
        pairs[i] &&
        typeof pair === 'object' &&
        typeof pairs[i] === 'object'
      ) {
        mergeSound(pair, pairs[i]);
      }
    });
  }
  if (
    'dialogues' in obj &&
    'dialogues' in src &&
    Array.isArray(obj.dialogues) &&
    Array.isArray(src.dialogues)
  ) {
    const dialogues = src.dialogues;
    obj.dialogues.forEach((dialogue, i) => {
      if (
        dialogue &&
        dialogues[i] &&
        typeof dialogue === 'object' &&
        typeof dialogues[i] === 'object'
      ) {
        mergeSound(dialogue, dialogues[i]);
      }
    });
  }
};
